export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TALKS FROM OUR COMMUNITY"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discuss with the community"])}
}